import { render, staticRenderFns } from "./FormTags.vue?vue&type=template&id=48560f7a"
import script from "./FormTags.vue?vue&type=script&lang=js"
export * from "./FormTags.vue?vue&type=script&lang=js"
import style0 from "./FormTags.vue?vue&type=style&index=0&id=48560f7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports